import { memo } from "react";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

import type { GuestCountOption } from "../../model/build-guest-count-options";

type Props = {
	guestCountOptions: GuestCountOption[];
	selectedGuestAdultNum: number;
	onChangeGuestAdultNum: (value: number) => void;
};

/**
 * セルに出す人数セレクト。年月セレクトと横並びできるよう、内容に見合う幅に抑える。
 */
export const PlanRateMatrixGuestCountSelect = memo(
	({ guestCountOptions, selectedGuestAdultNum, onChangeGuestAdultNum }: Props) => {
		const guestFormOptions: FormOptionType[] = guestCountOptions.map((option) => ({
			id: String(option.value),
			value: String(option.value),
			label: option.label,
		}));

		return (
			<div className="flex flex-col gap-y-4">
				<h5 className="font-semibold">セルに表示する人数</h5>
				<div className="mx-4">
					<SelectField
						className="w-36"
						value={String(selectedGuestAdultNum)}
						options={guestFormOptions}
						handleValueChange={(value) => onChangeGuestAdultNum(Number(value))}
					/>
				</div>
			</div>
		);
	},
);

PlanRateMatrixGuestCountSelect.displayName = "PlanRateMatrixGuestCountSelect";
